import { IntlShape, createIntlCache, createIntl } from "react-intl";
import locales from "../locales";

interface ExtendedIntlShape extends IntlShape {
  locale: string;
}

export const getLocale = (): string =>
  document.querySelector("html").getAttribute("lang") || "en-US";

const cache = createIntlCache();
const locale = getLocale();

const i18n: ExtendedIntlShape = createIntl(
  {
    locale,
    messages: locales[locale],
  },
  cache
);

i18n.locale = locale;

export default i18n;
